import { client } from "@lib/api"
import useSWR from "swr"

type SupportedVirtualAccount = {
    id: string
    code: string
    code_number: string
    name: string
    display_name: string
    icon_url: string
    max_amount: number
    min_amount: number
    cut_off_time?: {
        start: string
        end: string
    }
    is_default_fallback?: boolean
}

const useSupportedVirtualAccount = () => {
    const {data, error, isLoading} = useSWR('/v2/wallet/supported-virtual-account', client.doGet)
    return {
        data: data as SupportedVirtualAccount[] | undefined,
        isLoading,
        error
    }
}

export default useSupportedVirtualAccount
